<template>
  <div>
    <template v-if="loading">
      <div
        class="d-flex vertical-center justify-content-center align-items-center"
        style="height: 50vh; display: flex"
      >
        <LoadingMDL />
      </div>
    </template>
    <template v-else>
      <CModal
        title="Test has been closed."
        centered
        color="light"
        :show.sync="adminLockTestModal"
        :closeOnBackdrop="false"
      >
        <h5>Contact the instructor of your section and try again later.</h5>
        <br />
      </CModal>
      <CModal
        :title="this.lang === 'TH' ? 'ข้อควรทราบ' : 'Important Notice'"
        centered
        color="warning"
        :show.sync="warningTestModal"
        :closeOnBackdrop="false"
      >
        <h5>
          {{
            this.lang === 'TH'
              ? 'แบบทดสอบนี้สามารถทำได้เพียงครั้งเดียว กรุณาทำให้เสร็จจนจบหากออกจากระบบหรือหลุดระหว่างทำ คะแนนจะไม่ถูกบันทึก'
              : ' This test can be taken only once. Please complete it in one session. If you leave or are logged out before finishing, your score will not be saved.'
          }}
        </h5>

        <!-- <br /> -->
        <template slot="footer">
          <div class="d-flex justify-content-end gap-2">
            <CButton color="secondary" @click="warningTestModal = false">
              Cancel
            </CButton>
            <CButton color="success" class="ml-2" @click="proceedToTest">
              OK
            </CButton>
          </div>
        </template>
      </CModal>
      <div class="CIT_background">
        <div class="position" style="display: flex; flex-direction: column">
          <div class="container_CIT02">
            <div class="block">
              <Card :imgUrl="baseUrl + content" />
            </div>
            <div class="btn-exit">
              <ButtonIcon
                :bgColor="`#ed8e91`"
                :iconUrl="'close.png'"
                :size="1"
                :url_image="false"
                @click="onClose(navigate.close.action)"
              />
            </div>
          </div>
          <CRow
            style="
              display: flex;
              justify-content: center;
              margin: 0;
              padding: 0;
            "
          >
            <div
              class="button button_setting"
              @click="onNextRoute(navigate.next.action)"
            >
              <CCol col="8">
                <div class="font_size">START</div>
              </CCol>
              <CCol col="2">
                <i class="fas fa-caret-right fa-5x" style=""></i>
              </CCol>
            </div>
          </CRow>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ButtonIcon from '@/components/elements/Buttons/ButtonIcon';
import Card from '@/components/elements/Card';
import LoadingMDL from '@/components/loading/LoadingMDL';
import {mapGetters} from 'vuex';

export default {
  components: {ButtonIcon, Card, LoadingMDL},
  name: 'CIT02',
  props: {},
  data() {
    return {
      content: [],
      loading: true,
      baseUrl: process.env.VUE_APP_URL_SOUND,
      navigate: [],
      templateData: {},
      startTime: this.$helpers.getDateFormat(),
      condition: [],
      code: '',
      section: '',
      v3Data: null,
      adminLockTestModal: false,
      nextRouteCodeItem: null,
      nextPath: null,
      warningTestModal: false,
      lang: '',
    };
  },
  methods: {
    onNextRoute: function (route) {
      //checking Lock Test Here !
      const urlStr = this.content;
      if (urlStr == '/chinese2/Picture/ICON%20TEST.png') {
        console.log('next test');

        const lessonCodeItem = this.$store.state.v3.lessonCode;

        const payload = {
          courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
          section: this.$store.state.v3.v3EnrollData.data.section,
          codeItem: `${lessonCodeItem}`,
        };

        this.$store.dispatch('v3-data/v3LessonLockStatus', payload);

        //add nextRoute
        this.nextRouteCodeItem = route;
      } else {
        //if not test operate normally
        this.$store.commit('v3/stampMainCodeItem', route); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล
        this.commitUserProgress(route);
      }
    },
    onClose: function (route) {
      const str = route.split('-');
      const path = `/v4/${str[0]}/${str[1]}`;
      this.$router.push(path);
    },
    commitUserProgress: function (path) {
      console.log('commit userProgress');

      //payload here
      const payload = {
        codeItem: this.v3Data.codeItem,
      };

      //commit add payload stack
      this.$store.commit('v4/addPayloadStack', payload);
      //var
      const currentDataStack = [...this.$store.state.v4.v4DataStack];
      const currentCodeItem = this.v3Data.codeItem;
      //get last code item form backend
      const lastCodeItem = this.v3Data.lastContent;
      //check store
      if (currentDataStack.length === 0) {
        //no dispatch if array empty
      } else {
        if (currentCodeItem === lastCodeItem) {
          this.$store.dispatch('v4/v4ProgressAndScoreCalc', {
            mainCodeItem: this.v3Data.mainCodeItem,
            mainType: this.v3Data.mainType,
            mainContent: this.v3Data.mainContent,
            dataStack: currentDataStack,
            pages: this.v3Data.pages,
            courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
            section: this.$store.state.v3.v3EnrollData.data.section,
          });

          this.nextPath = path;
        } else {
          //onNext
          const splitPath = path.split('-');
          const nextPath = `/v4/${splitPath[0]}/${splitPath[1]}`;
          this.$router.push(nextPath);
        }
      }
    },
    proceedToTest() {
      this.loading = true;

      this.$store.commit('v3/stampMainCodeItem', this.nextRouteCodeItem); // บันทึกข้อมูลตัวแม่ของชุดข้อมูล

      this.commitUserProgress(this.nextRouteCodeItem);
    },
  },
  computed: {
    ...mapGetters({
      getTemplatev3: 'v3/getTemplates',
      v3LessonLockStatus: 'v3-data/v3LessonLockStatus',
      saveContentStatusv4: 'v4-data/saveContentStatusv4',
    }),
    storeLang() {
      return this.$store.getters['language/getLanguage'];
    },
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;
      const template = val.templates[0];
      this.content = template.content.image;
      this.navigate = template.navigate;

      //checking
      this.$store.dispatch('v4/checkCurrentMainCode', this.v3Data);

      this.loading = false;
    },

    v3LessonLockStatus: function (val) {
      //check Test status before redirect
      if (val.isLock) {
        //if isLock true
        //alert cannot do test since is locking
        this.adminLockTestModal = true;
      } else {
        ///show modal before click submit or no do nothing
        this.warningTestModal = true;
        //isLock is false
      }
    },
    saveContentStatusv4: function (val) {
      console.log(val, 'CIT02 saveContent Call');
      //if this next path exist
      if (this.nextPath) {
        this.loading = true;

        const splitPath = this.nextPath.split('-');
        const onNext = `/v4/${splitPath[0]}/${splitPath[1]}`;
        //to LTK 01
        this.$router.push(onNext);
      }
    },
    storeLang(val) {
      this.lang = val;
    },
  },
  created() {
    this.lang = this.$store.state.language.language;
    this.currentRoute = this.$route.name + '-' + this.$route.params.id;
    this.courseData = this.$store.getters['necessary/getLerningCourse'];
    this.code = this.courseData._id;
    this.section = this.$store.getters['necessary/getUserCourseSection'];
  },
  mounted() {
    this.$store.dispatch('v3/fetchTemplateByCode', this.currentRoute);
  },
  beforeDestroy() {},
};
</script>

<style scoped lang="scss">
.CIT_background {
  background-color: #ffdc77;
}

.position {
  margin-top: 3%;
  display: flex;
  align-content: center;
  justify-content: center;
}

.block {
  width: 450px;
  height: 450px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
  border-radius: 20px;
}

.card {
  width: 400px;
  height: 400px;
  background-color: white;
  border-radius: 20px;
  /* 5px rounded corners */
  border: 0px solid;
}

.btn-exit {
  right: 34%;
  position: absolute;
  width: 60px;
  height: 60px;
  // margin-left: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.container_CIT02 {
  margin-top: 10%;
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.button_setting {
  background-color: #f1b205;
  color: white;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  border-radius: 10px !important;
  box-shadow: none;
  margin-top: 6%;
  margin-bottom: 5%;
  width: 250px;
  height: 70px;
}

.font_size {
  font-size: 18px;
}

// resolution mobile
@media screen and (min-width: 300px) and (max-width: 600px) {
  .position {
    padding-top: 20%;
    padding-bottom: 20%;
  }

  .container_CIT02 {
    margin-top: 20%;
  }

  .block {
    margin-top: 20px;
    width: 250px;
    height: 250px;
  }

  .card {
    width: 250px;
    height: 250px;
  }

  .button_setting {
    width: 150px;
    height: 50px;
  }

  .fa-caret-right {
    font-size: 30px;
  }

  .font_size {
    font-size: 12px;
  }

  .btn-exit {
    width: 70px;
    height: 70px;
    padding: 10px;
    right: -1%;
    font-size: 30px;
  }
}

// resolution ipad
@media only screen and (min-width: 700px) and (max-width: 821px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 10%;
  }
}

// resolution ipad pro
@media only screen and (min-width: 1024px) and (max-width: 1025px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 20%;
  }

  .position {
    margin-top: 0;
  }
}

@media only screen and (min-width: 1030px) and (max-width: 1366px) {
  .btn-exit {
    right: 22%;
  }
}

// PC MAX 1800
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 32%;
  }

  .position {
    margin-top: 0;
  }

  .button_setting {
    margin-top: 5%;
  }
}

// PC MAX 1600
@media only screen and (min-width: 1366px) and (max-width: 1600px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}

// PC MAX 1400
@media only screen and (min-width: 1367px) and (max-width: 1400px) {
  .btn-exit {
    width: 60px;
    height: 60px;
    right: 28%;
  }
}
</style>
